export default __webpack_public_path__ + "static/media/RTR1602V_LateralIzq.29d0742b.webp";